import styled from "styled-components";

export const StyledButton = styled("button")<{ color?: string }>`
  background: ${(p) => p.color || "#353839"};
  color: ${(p) => (p.color ? "#353839" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 0;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  border-radius: 8px;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    background-color: rgb(255, 130, 92);
  }
`;
